'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Functions$BsBastet = require("bs-bastet/bastet/src/Functions.bs.js");

function FunctorExtensions(F) {
  var BsFunctorExtensions = Functions$BsBastet.Functor(F);
  var flipMap = function (fa, f) {
    return Curry._2(F.map, f, fa);
  };
  return {
          BsFunctorExtensions: BsFunctorExtensions,
          flipMap: flipMap,
          $$void: BsFunctorExtensions.$$void,
          voidRight: BsFunctorExtensions.void_right,
          voidLeft: BsFunctorExtensions.void_left,
          flap: BsFunctorExtensions.flap
        };
}

function FunctorInfix(F) {
  var BsFunctorExtensions = Functions$BsBastet.Functor(F);
  var flipMap = function (fa, f) {
    return Curry._2(F.map, f, fa);
  };
  var voidRight = BsFunctorExtensions.void_right;
  var voidLeft = BsFunctorExtensions.void_left;
  var flap = BsFunctorExtensions.flap;
  var FunctorExtensions_void = BsFunctorExtensions.$$void;
  var FunctorExtensions = {
    BsFunctorExtensions: BsFunctorExtensions,
    flipMap: flipMap,
    $$void: FunctorExtensions_void,
    voidRight: voidRight,
    voidLeft: voidLeft,
    flap: flap
  };
  return {
          FunctorExtensions: FunctorExtensions,
          $less$$great: F.map,
          $less$hash$great: flipMap,
          $less$: voidRight,
          $$great: voidLeft,
          $less$at$great: flap
        };
}

exports.FunctorExtensions = FunctorExtensions;
exports.FunctorInfix = FunctorInfix;
/* Functions-BsBastet Not a pure module */
